import { AppStateProvider } from '../providers/appStateProvider';

export const GET_APPSTATE = 'GET_APPSTATE';
export const GET_APPSTATE_PENDING = 'GET_APPSTATE_PENDING';
export const GET_APPSTATE_REJECTED = 'GET_APPSTATE_REJECTED';
export const GET_APPSTATE_FULFILLED = 'GET_APPSTATE_FULFILLED';

export const SET_APPSTATE = 'SET_APPSTATE';
export const SET_APPSTATE_PENDING = 'SET_APPSTATE_PENDING';
export const SET_APPSTATE_REJECTED = 'SET_APPSTATE_REJECTED';
export const SET_APPSTATE_FULFILLED = 'SET_APPSTATE_FULFILLED';

export const CHANGE_MAP_LAYER_ID = 'CHANGE_MAP_LAYER_ID';
export const UPDATE_APP_STATE = 'UPDATE_APP_STATE';

export function getAppState()
{
    return {
        type: GET_APPSTATE,
        payload: _getAppState()
    };
}

async function _getAppState()
{
    const op = new AppStateProvider();
    return await op.getAppState();
}

export function setAppState(appState, allowStorageAccess)
{
    return {
        type: SET_APPSTATE,
        payload: _setAppState(appState, allowStorageAccess)
    };
}

async function _setAppState(appState, allowStorageAccess)
{
    const op = new AppStateProvider(allowStorageAccess);
    return await op.setAppState(appState, allowStorageAccess);
}

export function changeMapLayerIdAction(layerId)
{
    return {
        type: CHANGE_MAP_LAYER_ID,
        payload: layerId
    };
}

export function updateAppState(state) {
    return {
        type: UPDATE_APP_STATE,
        payload: state
    };
}
